/** Order is a product contract: use this registry for validation and Profile options. */
export const UI_LOCALES = ["en", "uk", "de", "bg", "pt-PT", "es", "ru"] as const
export type UiLocale = (typeof UI_LOCALES)[number]

export const DEFAULT_UI_LOCALE: UiLocale = "en"
// Enable a language only after its complete catalog has passed translation checks.
export const RELEASED_UI_LOCALES: readonly UiLocale[] = ["en", "uk", "de", "bg", "pt-PT", "es", "ru"]
export const UI_LOCALE_LABELS: Record<UiLocale, string> = {
  en: "English", uk: "Українська", de: "Deutsch", bg: "Български",
  "pt-PT": "Português (Portugal)", es: "Español", ru: "Русский",
}
export const UI_LOCALE_OPTIONS = RELEASED_UI_LOCALES.map(value => ({ value, label: UI_LOCALE_LABELS[value] }))

export const UI_LOCALE_COOKIE = "versafy.ui-locale"
export const UI_LOCALE_COOKIE_MAX_AGE = 365 * 24 * 60 * 60

export function isUiLocale(value: unknown): value is UiLocale {
  return typeof value === "string" && UI_LOCALES.some(locale => locale === value)
}

export function isReleasedUiLocale(value: unknown): value is UiLocale {
  return isUiLocale(value) && RELEASED_UI_LOCALES.includes(value)
}
